module.exports = __webpack_public_path__ + "img/link-variant.9cb72b3d.svg";